<template>
  <div class="main-footer font-size13">
    <p class="mb-2 text-black content">
      ［注意事項］
      施設情報については、更新時点での情報となり、サービス提供企業の都合により現状の情報が異なる場合があります。
    </p>
    <p class="text-primary">
      ※施設に直接お申込みいただくことは出来ません。
      直接お申込みの場合、弊社プランへの予約変更は出来ないことをご了承ください。
    </p>
    <p class="text-primary">&emsp; 上記タブ「プラン」からお申込みください。</p>
    <p class="text-primary">
      ※一度成立したご予約内容の変更はできません。いったんキャンセルのお手続き後、再度ご予約ください。
    </p>

    <p v-if="isRakuten" class="text-primary">
      ※キャンセル料金が発生した場合、施設へ直接キャンセル料金をお支払いいただきます。
    </p>
    <p v-if="isRakuten" class="text-primary">
      ※Bene楽天トラベルプランをお申し込み時には、楽天会員IDとパスワードが必要となります。
    </p>
    <p v-if="isRakuten" class="text-primary">
      ※Bene楽天トラベルプランは、楽天トラベル宿泊予約センターでの予約申込はできません。
    </p>
  </div>
</template>
  
<script>
export default {
  name: 'MainFooterSection',
  props: {
    isRakuten: {
      type: [Boolean],
      default: false
    },
    wrapperClass: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
@import './styles.scss';
</style>  